import { Injectable } from '@angular/core';

import { translationHelper } from '~/helpers/translation.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { lg } from '~/modules/colorLog';

@Injectable()
export class OddConstant {
    // b.replace(/\{((\s*?.*?)*?)\}/g, (x,y)=> {return y })
    public ODD_VARIETY = {};

    /*


Yeni odd type eklemek için:
ODD_TYPE => id verip array olarak yukarda ne yazması gerektiğini giriyorsun.
ODD_TYPE_DROPDOWN => burada ise dropdown'da ne yazması gerektiğinin bilgisini giriyorsun.
ODD_TYPE_DROPDOWN'nun içindeki odd_type => ODD_TYPE ile eşleşmeli.

initial değer tanımlamak için; headerTop.ts'de tanımlanması gerekli.

oddDropDown = {
first:[
this._OddConstant.ODD_TYPE_DROPDOWN.RoM,
],

Son olarak; ODD_TYPE_ID'ye istenilen odd type'ın id'si girilmeli. pre-sport type ve live olarak ayrı ayrı.

*/

    public ODD_TYPE;

    public ODD_TYPE_DROPDOWN;
    /*


SPORT BELOW TAXONOMY BY SPORT TYPE ENUM

sport.constant.ts


*/

    public ODD_DROPDOWN_BY_SPORT;
    public ODD_TYPE_EQUIVALENT_2ND_ROW;

    // RoM ve 3way gibi birbirinin equvalenti olan işlemler için equvialent tanımlanabilir.
    public ODD_TYPE_EQUIVALENT;

    public ODD_TYPE_ID;

    public ODD_TYPE_SEQUENCE_ID;

    // EXPAND LIST
    public groupHandler = {
        specialBet: (arrayOfOdds, ITEM_DATA, isHalf?) => {
            let COL = ITEM_DATA.col;
            COL = ITEM_DATA.groupRow ? ITEM_DATA.col * ITEM_DATA.groupRow : ITEM_DATA.col;
            const returnedArrayofOdds = [];
            arrayOfOdds.forEach(oddArrayItem => {
                const mainOdds = [];
                let accumulatorOfOdds = [];

                if (ITEM_DATA.textLocation === 'outside') {
                    // Position based filling for outside text location
                    const oddsMap = new Map();

                    // First, try to use Position values from the data
                    oddArrayItem.forEach(item => {
                        if (typeof item.Position === 'number') {
                            oddsMap.set(item.Position, item);
                        }
                    });

                    // If no Position values found, create positions based on specialText order
                    if (oddsMap.size === 0 && ITEM_DATA.specialText && ITEM_DATA.specialText.length > 0) {
                        const textToPositionMap = new Map();
                        ITEM_DATA.specialText.forEach((text, idx) => {
                            textToPositionMap.set(text.toLowerCase(), idx);
                        });

                        oddArrayItem.forEach(item => {
                            const outcome = item.OutCome ? item.OutCome.toLowerCase() : '';
                            const position = textToPositionMap.get(outcome);
                            if (typeof position === 'number') {
                                oddsMap.set(position, item);
                            }
                        });
                    }

                    // If still no mapping, try to match by index
                    if (oddsMap.size === 0) {
                        oddArrayItem.forEach((item, index) => {
                            oddsMap.set(index, item);
                        });
                    }

                    // Fill the accumulator with either existing odds or null values
                    for (let i = 0; i < COL; i++) {
                        const existingOdd = oddsMap.get(i);
                        if (existingOdd) {
                            accumulatorOfOdds.push(existingOdd);
                        } else {
                            accumulatorOfOdds.push(null);
                        }

                        if (accumulatorOfOdds.length === COL) {
                            mainOdds.push(accumulatorOfOdds);
                            accumulatorOfOdds = [];
                        }
                    }
                } else {
                    // Regular filling for inside text location
                    oddArrayItem.forEach((item, index) => {
                        accumulatorOfOdds.push(item);
                        if ((index + 1) % COL === 0) {
                            mainOdds.push(accumulatorOfOdds);
                            accumulatorOfOdds = [];
                        }
                    });
                }

                if (ITEM_DATA.notRequiredFull && accumulatorOfOdds.length > 0) {
                    mainOdds.push(accumulatorOfOdds);
                }

                returnedArrayofOdds.push({
                    SpecialBetValue: '',
                    isHighlighted: '',
                    isAppend: isHalf,
                    isDoubleRow: ITEM_DATA.groupRow > 1,
                    gridWidth: ITEM_DATA.gridWidth,
                    rows: mainOdds,
                });
            });

            return returnedArrayofOdds;
        },
        byOutCome: x => x,
        correctScore: (arrayOfOdds, ITEM_DATA) => {
            const returnedArrayofOdds = [];

            arrayOfOdds.forEach(oddArrayItem => {
                const mainOdds = [];
                let accumulatorOfOdds = [];
                let mainCounter = 7;
                let counter = 0;
                oddArrayItem.forEach((item, index) => {
                    item.OddValue = item.OddValue.slice(0, 5);
                    accumulatorOfOdds.push(item);
                    counter++;
                    if (mainCounter === counter) {
                        mainOdds.push(accumulatorOfOdds);
                        accumulatorOfOdds = [];
                        counter = 0;
                        mainCounter--;
                    }
                });

                returnedArrayofOdds.push({
                    SpecialBetValue: '',
                    isHighlighted: '',
                    isDoubleRow: ITEM_DATA.groupRow > 1,
                    gridWidth: ITEM_DATA.gridWidth,
                    rows: mainOdds,
                });
            });

            return returnedArrayofOdds;
        },
    };

    public specialTextHandler = {
        outCome: (item, ITEM_DATA) => {
            return item.OutCome;
        },
    };

    public specialBetValueHandler = {
        firstHalf: (item, ITEM_DATA) => {
            return `1.${this._translate.getT('half')}`;
        },
        secondHalf: (item, ITEM_DATA) => {
            return `2.${this._translate.getT('half')}`;
        },
    };

    public filterHandler = {
        goalScorer: items => {
            return items[0].filter(x => x.OddValue < 4);
        },
        reOrder154: items => {
            const item = items[0].sort((a, b) => a.OddId - b.OddId);
            return [...item.slice(3, 6), ...item.slice(0, 3)];
        },
    };

    public EXPAND_LIST_PRE;

    public EXPAND_LIST_LIVE;

    public forbiddenOddTypes;

    // EXPAND LIST (END)

    // Applied for there odd view decrease to TWO only. Which means only apply for first and third row.
    public DECREASED_ITEM_NUM_BY_SPORT;

    public LIST_REBUILD = {};

    constructor(private _translate: translationHelper) {}

    expandDataJobs(_data) {
        let _retData = {};
        const transformData = row => {
            if (row.groupHandler) {
                row.groupHandler = this.groupHandler[row.groupHandler];
            }
            if (row.filterHandler) {
                row.filterHandler = this.filterHandler[row.filterHandler];
            }
            if (row.specialTextHandler) {
                row.specialTextHandler = this.specialTextHandler[row.specialTextHandler];
            }
            if (row.specialBetValueHandler) {
                row.specialBetValueHandler = this.specialBetValueHandler[row.specialBetValueHandler];
            }
            if (row.specialText) {
                row.specialText = row.specialText.map(itemST => this._translate.transformTranslate(itemST));
            }

            return row;
        };
        Object.keys(_data).forEach(item => {
            _retData[item] = transformData(_data[item]);
            if (_retData[item].appendOdds) {
                Object.keys(_retData[item].appendOdds).forEach(itemAppend => {
                    _retData[item].appendOdds[itemAppend] = transformData(_data[item].appendOdds[itemAppend]);
                });
            }
        });

        return _retData;
    }

    DATA_INITIALIZER = _data =>
        new Promise<void>(done => {
            // console.log(_data);
            let _data2 = {
                /**
                 *  That area for special bet value odds.
                 *  For example, Over/under odds can be various special bet values according to sports
                 */
                ODD_VARIETY: {
                    OU: [
                        '0.5',
                        '1.5',
                        '2.5',
                        '3.5',
                        '4.5',
                        '5.5',
                        '6.5',
                        '7.5',
                        '8.5',
                        '9.5',
                        '40.5',
                        '41.5',
                        '42.5',
                        '43.5',
                        '44.5',
                        '45.5',
                        '46.5',
                        '47.5',
                        '48.5',
                        '49.5',
                        '50.5',
                        '51.5',
                        '52.5',
                        '53.5',
                        '54.5',
                        '55.5',
                        '56.5',
                        '57.5',
                        '58.5',
                        '59.5',
                        '60.5',
                        '61.5',
                        '62.5',
                        '63.5',
                        '64.5',

                        '147.5',
                        '148.5',
                        '149.5',
                        '150.5',
                        '151.5',
                        '152.5',
                        '153.5',
                        '155.5',
                        '157.5',
                        '161.5',
                        '163.5',
                        '165.5',
                        '166.5',
                        '168.5',
                        '169.5',
                        '171.5',
                        '172.5',
                        '173.5',
                        '174.5',
                        '175.5',
                        '176.5',
                        '177.5',
                        '178.5',
                        '179.5',
                        '180.5',
                        '181.5',
                        '182.5',
                        '183.5',
                        '184.5',
                        '185.5',
                        '186.5',
                        '188.5',
                        '189.5',
                        '190.5',
                        '191.5',
                        '192.5',
                        '193.5',
                        '194.5',
                        '195.5',
                        '196.5',
                        '197.5',
                    ],
                    HANDICAP: ['0:1', '0:1', '0:2', '1:0', '2:0', '0:0.5', '0:1.5', '0:2.5', '0.5:0', '1.5:0', '2.5:0'],
                    HANDICAP_basket: [
                        '0:0.5',
                        '0:1.5',
                        '0:2.5',
                        '0:3.5',
                        '0:4.5',
                        '0:5.0',
                        '0:5.5',
                        '0:6.5',
                        '0:7.5',
                        '0:8.5',
                        '0:9.5',
                        '0:10.5',
                        '0:11.5',
                        '0:12.5',
                        '0:13.5',
                        '0:14.5',
                        '0:15.5',
                        '0:16.5',
                        '0:17.5',
                        '0:18.5',
                        '0:19.5',
                        '0:20.5',
                        '1.5:0',
                        '2.5:0',
                        '3.5:0',
                        '4.5:0',
                        '5.5:0',
                        '6.5:0',
                        '7.5:0',
                        '8.5:0',
                        '9.5:0',
                        '10.5:0',
                        '11.5:0',
                        '12.5:0',
                        '13.5:0',
                        '14.5:0',
                        '15.5:0',
                        '16.5:0',
                        '17.5:0',
                        '18.5:0',
                        '19.5:0',
                        '20.5:0',
                    ],
                    HANDICAP_handball: [
                        '0:0',
                        '0:1',
                        '0:2',
                        '0:3',
                        '0:4',
                        '0:5',
                        '0:5',
                        '0:0.5',
                        '0:1.5',
                        '0:2.5',
                        '0:3.5',
                        '0:4.5',
                        '0:5.5',
                        '0:5.5',
                        '0:6',
                        '0:7',
                        '0:8',
                        '0:9',
                        '0:10',
                        '1:0',
                        '2:0',
                        '3:0',
                        '4:0',
                        '5:0',
                        '1.5:0',
                        '2.5:0',
                        '3.5:0',
                        '4.5:0',
                        '5.5:0',
                        '6:0',
                        '7:0',
                        '8:0',
                        '9:0',
                        '10:0',
                    ],
                    HANDICAP_baseball: [
                        '0.5',
                        '1.5',
                        '2.5',
                        '3.5',
                        '4.5',
                        '5.5',
                        '6.5',
                        '7.5',
                        '8.5',
                        '-0.5',
                        '-1.5',
                        '-2.5',
                        '-3.5',
                        '-4.5',
                        '-5.5',
                        '-6.5',
                        '-7.5',
                        '-8.5',
                    ],
                    SET: ['', '1', '2', '3', '4'],
                },
                /**
                 * ODD_TYPE field defines odds header values. Can use with translation data.
                 */
                ODD_TYPE: {
                    RoM: ['1', 'X', '2'],
                    RoM_woDraw: ['1', '2'],
                    RoM_abbr: ['{RoM_abbr_char} 1', '{RoM_abbr_char} X', '{RoM_abbr_char} 2'],
                    RoM_basket: ['1', '2', ''],
                    RoM_tennis: ['1', '2', ''],
                    MATCHRESULT: ['1', 'X', '2'],
                    HANDICAP: ['1', 'X', '2'],
                    DOUBLE: ['1X', '12', 'X2'],
                    OU: ['+', '-'],
                    OU_noSpecial: ['+', '-'],
                    OU_noSpecialTennis: ['+', '-'],
                    GOAL_NO_GOAL: ['{Yes}', '{No}'],
                    NG: ['1', 'X', '2'],
                    SET: ['1', '2'],
                    NaN: [''],
                },
                /**
                 * ODD_TYPE_DROPDOWN defines ODD_TYPE's settings. More than one odd type dropdown item can be equal one type.
                 * For example over/under 1.5 and  over/under 2.5 equal "OU" type.
                 *
                 * @param wildcard {boolean} that use when if odd type came from
                 *
                 */
                ODD_TYPE_DROPDOWN: {
                    RoM: {
                        key: 'RoM',
                        name: '{RestofMatch}',
                        odd_type: 'RoM',
                    },
                    RoM_woDraw: {
                        key: 'RoM_woDraw',
                        name: '{RestofMatch}',
                        odd_type: 'RoM_woDraw',
                    },
                    RoM_basket: {
                        key: 'RoM_basket',
                        name: '{twoWay}',
                        odd_type: 'RoM_basket',
                    },
                    RoM_tennis: {
                        key: 'RoM_tennis',
                        name: '{twoWay}',
                        odd_type: 'RoM_tennis',
                    },
                    OU: {
                        key: 'OU',
                        name: '{Over}/{Under}',
                        odd_type: 'OU',
                        wildcard: true,
                    },
                    OU_noSpecial: {
                        key: 'OU_noSpecial',
                        name: '{Over}/{Under}',
                        odd_type: 'OU_noSpecial',
                        wildcard: true,
                        isDataContainSameObject: true,
                    },
                    OU_noSpecialTennis: {
                        key: 'OU_noSpecialTennis',
                        name: '{Over}/{Under}',
                        odd_type: 'OU_noSpecialTennis',
                        wildcard: true,
                        isDataContainSameObject: true,
                    },
                    OU_noSpecial_handball: {
                        key: 'OU_noSpecial_handball',
                        name: '{Over}/{Under}',
                        odd_type: 'OU_noSpecial_handball',
                        wildcard: true,
                        isDataContainSameObject: true,
                    },
                    OU_05: {
                        key: 'OU_05',
                        name: '{Over}/{Under} 0.5',
                        odd_type: 'OU',
                        SpecialBetValue: '0.5',
                    },
                    OU_15: {
                        key: 'OU_15',
                        name: '{Over}/{Under} 1.5',
                        odd_type: 'OU',
                        SpecialBetValue: '1.5',
                    },
                    OU_25: {
                        key: 'OU_25',
                        name: '{Over}/{Under} 2.5',
                        odd_type: 'OU',
                        SpecialBetValue: '2.5',
                    },
                    OU_35: {
                        key: 'OU_35',
                        name: '{Over}/{Under} 3.5',
                        odd_type: 'OU',
                        SpecialBetValue: '3.5',
                    },
                    OU_45: {
                        key: 'OU_45',
                        name: '{Over}/{Under} 4.5',
                        odd_type: 'OU',
                        SpecialBetValue: '4.5',
                    },
                    OU_55: {
                        key: 'OU_55',
                        name: '{Over}/{Under} 5.5',
                        odd_type: 'OU',
                        SpecialBetValue: '5.5',
                    },
                    OU_65: {
                        key: 'OU_65',
                        name: '{Over}/{Under} 6.5',
                        odd_type: 'OU',
                        SpecialBetValue: '6.5',
                    },
                    OU_75: {
                        key: 'OU_75',
                        name: '{Over}/{Under} 7.5',
                        odd_type: 'OU',
                        SpecialBetValue: '7.5',
                    },
                    OU_85: {
                        key: 'OU_85',
                        name: '{Over}/{Under} 8.5',
                        odd_type: 'OU',
                        SpecialBetValue: '8.5',
                    },
                    OU_95: {
                        key: 'OU_95',
                        name: '{Over}/{Under} 9.5',
                        odd_type: 'OU',
                        SpecialBetValue: '9.5',
                    },
                    NG: {
                        key: 'NG',
                        name: '{NextGoal}',
                        odd_type: 'NG',
                    },
                    HALF_NG: {
                        key: 'HALF_NG',
                        name: 'Half Time - {NextGoal}',
                        odd_type: 'HALF_NG',
                    },
                    HANDICAP: {
                        key: 'HANDICAP',
                        name: '{handicap}',
                        odd_type: 'HANDICAP',
                        wildcard: true,
                    },
                    HANDICAP_basket: {
                        key: 'HANDICAP_basket',
                        name: '{handicap}',
                        odd_type: 'HANDICAP_basket',
                        wildcard: true,
                    },
                    HANDICAP_handball: {
                        key: 'HANDICAP_handball',
                        name: '{handicap}',
                        odd_type: 'HANDICAP_handball',
                        wildcard: true,
                    },
                    HANDICAP_baseball: {
                        key: 'HANDICAP_baseball',
                        name: '{handicap}',
                        odd_type: 'HANDICAP_baseball',
                        wildcard: true,
                    },
                    GOAL_NO_GOAL: {
                        key: 'GOAL_NO_GOAL',
                        name: '{goalNoGoal}',
                        odd_type: 'GOAL_NO_GOAL',
                    },
                    DOUBLE: {
                        key: 'DOUBLE',
                        name: '{doubleChance}',
                        odd_type: 'DOUBLE',
                    },
                    MATCHRESULT: {
                        key: 'MATCHRESULT',
                        name: '{threeWay}',
                        odd_type: 'MATCHRESULT',
                    },
                    SET: {
                        key: 'SET',
                        name: '{set}',
                        odd_type: 'SET',
                        wildcard: true,
                        selectLower: false,
                        // selectLower =>  Tenis için false yapıldı. Oynanan Setin datası gelmesi için bu değişiklik yapıldı
                    },
                    RoM_SCORE_BOX: {
                        key: 'RoM',
                        name: '{RestofMatch}',
                        odd_type: 'RoM_abbr',
                    },
                    NaN: {
                        isEmptyType: true,
                        key: 'NaN',
                        name: '',
                        odd_type: 'NaN',
                    },
                },
                ODD_DROPDOWN_BY_SPORT: {
                    '1': {
                        first: ['RoM'],
                        second: [
                            'OU',
                            'OU_05',
                            'OU_15',
                            'OU_25',
                            'OU_35',
                            'OU_45',
                            'OU_55',
                            'OU_65',
                            'OU_75',
                            'OU_85',
                            'OU_95',
                        ],
                        third: ['NG', 'HANDICAP', 'MATCHRESULT', 'GOAL_NO_GOAL', 'DOUBLE'],
                    },
                    '2': {
                        first: ['RoM_basket'],
                        second: ['OU_noSpecial'],
                        third: ['HANDICAP_basket'],
                    },
                    '3': {
                        first: ['RoM_woDraw'],
                        second: ['OU'],
                        third: ['HANDICAP_baseball'],
                    },
                    '4': {
                        first: ['RoM'],
                        second: ['OU'],
                        third: ['HANDICAP'],
                    },
                    '5': {
                        first: ['RoM_tennis'],
                        second: ['OU_noSpecialTennis'],
                        third: ['SET'],
                    },
                    '6': {
                        first: ['RoM'],
                        second: ['OU'],
                        third: ['HANDICAP_handball'],
                    },
                    '12': {
                        first: ['RoM_woDraw'],
                        second: ['NaN'],
                        third: ['NaN'],
                    },
                    '14': {
                        first: ['RoM_woDraw'],
                        second: ['OU'],
                        third: ['NaN'],
                    },
                    '19': {
                        first: ['RoM_woDraw'],
                        second: ['NaN'],
                        third: ['NaN'],
                    },
                    '35': {
                        first: ['RoM_woDraw'],
                        second: ['NaN'],
                        third: ['NaN'],
                    },
                    '20': {
                        first: ['RoM_tennis'],
                        second: ['OU'],
                        third: ['SET'],
                    },
                    scoreBox_live_1: {
                        first: ['RoM_SCORE_BOX'],
                        second: ['OU'],
                        third: ['NG'],
                    },
                    scoreBox_pre_1: {
                        first: ['MATCHRESULT'],
                        second: ['OU'],
                        third: ['HANDICAP'],
                    },
                },
                ODD_TYPE_EQUIVALENT_2ND_ROW: {
                    OU: '1stHalf_OU',
                    NG: '1stHalf_NG',
                    MATCHRESULT: '1stHalf_MATCHRESULT',
                    RoM: '1stHalf_RoM',
                    GOAL_NO_GOAL: '1stHalf_GOAL_NO_GOAL',
                    HANDICAP: '1stHalf_HANDICAP',
                    DOUBLE: '1stHalf_DOUBLE',
                },
                ODD_TYPE_EQUIVALENT: {
                    RoM: {
                        pre: {
                            '1': 1839,
                            '2': 1835,
                            '4': 1839,
                            '5': 1835,
                            '6': 1839,
                        },
                    },
                },
                ODD_TYPE_ID: {
                    live: {
                        '1': {
                            RoM: 3,
                            OU: 710,
                            NG: 11,
                            HALF_NG: 101,
                            HANDICAP: 709,
                            MATCHRESULT: 708,
                            GOAL_NO_GOAL: 27,
                            DOUBLE: 24,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            '1stHalf_GOAL_NO_GOAL': 736,
                            '1stHalf_HANDICAP': 95,
                            '1stHalf_DOUBLE': 195,
                            OU_noSpecial: 36,
                            SET: 9,
                        },
                        '2': {
                            RoM_basket: 34,
                            OU: 710,
                            HALF_NG: 101,
                            HANDICAP_basket: 35,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            '1stHalf_GOAL_NO_GOAL': 736,
                            OU_noSpecial: 36,
                            SET: 9,
                        },
                        '3': {
                            RoM: 3,
                            RoM_woDraw: 34,
                            OU: 616,
                            HALF_NG: 101,
                            HANDICAP_basket: 35,
                            MATCHRESULT: 708,
                            DOUBLE: 24,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            '1stHalf_GOAL_NO_GOAL': 736,
                            OU_noSpecial: 36,
                            SET: 9,
                        },
                        '4': {
                            RoM: 3,
                            OU: 710,
                            HALF_NG: 101,
                            HANDICAP: 709,
                            MATCHRESULT: 708,
                            DOUBLE: 24,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            '1stHalf_GOAL_NO_GOAL': 736,
                            OU_noSpecial: 36,
                            SET: 9,
                        },
                        '5': {
                            RoM_tennis: 8,
                            OU: 710,
                            HALF_NG: 101,
                            HANDICAP: 709,
                            MATCHRESULT: 708,
                            DOUBLE: 24,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            '1stHalf_GOAL_NO_GOAL': 736,
                            OU_noSpecialTennis: 77,
                            SET: 9,
                        },
                        '6': {
                            RoM: 1515,
                            OU: 710,
                            HALF_NG: 101,
                            HANDICAP: 709,
                            MATCHRESULT: 708,
                            SET: 1524,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            HANDICAP_basket: 1493,
                        },
                        // Volleyball
                        '20': {
                            RoM_tennis: 96,
                            OU: 710,
                            OU_noSpecial: 710,
                            HALF_NG: 101,
                            HANDICAP: 709,
                            MATCHRESULT: 708,
                            SET: 97,
                            '1stHalf_OU': 19,
                            '1stHalf_RoM': 18,
                            '1stHalf_MATCHRESULT': 20,
                            '1stHalf_NG': 101,
                            '1stHalf_GOAL_NO_GOAL': 736,
                        },

                        // Below here odds are useless, but still we keep for future reference :/

                        OU: 710,
                        NG: 11,
                        HALF_NG: 101,
                        HANDICAP: 709,
                        HANDICAP_basket: 35,
                        HANDICAP_handball: 31,
                        GOAL_NO_GOAL: 27,
                        RoM: 3,
                        RoM_basket: 34,
                        RoM_tennis: 8,
                        //RoM_handball: 708,
                        MATCHRESULT: 708,
                        DOUBLE: 24,
                        '1stHalf_OU': 19,
                        '1stHalf_RoM': 18,
                        '1stHalf_MATCHRESULT': 20,
                        '1stHalf_NG': 101,
                        '1stHalf_GOAL_NO_GOAL': 736,
                        OU_noSpecial: 36,
                        OU_noSpecialTennis: 77,
                        SET: 9,
                    },
                    pre: {
                        '1': {
                            RoM: 1839,
                            OU: 1516,
                            NG: 1460,
                            HANDICAP: 1513,
                            GOAL_NO_GOAL: 1467,
                            MATCHRESULT: 1839,
                            DOUBLE: 1481,
                        },
                        '2': {
                            RoM: 1835,
                            RoM_basket: 1835,
                            OU_noSpecial: 1500,
                            '2WAY': 1835,
                            HANDICAP: 1911,
                            HANDICAP_basket: 1911,
                            SET: 1743,
                        },
                        '3': {
                            RoM_woDraw: 1835,
                            OU: 1516,
                            HANDICAP_baseball: 1574,
                        },
                        '4': {
                            RoM: 1839,
                            OU: 1517,
                            HANDICAP: 1515,
                            MATCHRESULT: 1538,
                            DOUBLE: 1481,
                        },
                        '5': {
                            RoM: 1835,
                            RoM_tennis: 1835,
                            OU_noSpecialTennis: 1569,
                            SET: 1522,
                            '2WAY': 1835,
                        },
                        '6': {
                            RoM: 1839,
                            OU: 1502,
                            HANDICAP: 1493,
                            HANDICAP_handball: 1493,
                            OU_noSpecial: 1493,
                            MATCHRESULT: 1839,
                            DOUBLE: 1483,
                        },
                        '12': {
                            RoM_woDraw: 1839,
                        },
                        '14': {
                            RoM_woDraw: 1835,
                            OU: 1578,
                        },
                        '19': {
                            RoM_woDraw: 1835,
                        },
                        '35': {
                            RoM_woDraw: 1835,
                        },
                        '20': {
                            RoM_tennis: 1835,
                            OU: 1570,
                            OU_noSpecial: 1570,
                            SET: 1524,
                            HANDICAP: 1513,
                            GOAL_NO_GOAL: 1467,
                            MATCHRESULT: 1839,
                            DOUBLE: 1481,
                        },
                    },
                },
                ODD_TYPE_SEQUENCE_ID: {
                    live: {
                        '3': [6, 7, 8],
                        '8': [19, 20],
                        '9': [21, 22],
                        '34': [113, 114],
                        '35': [115, 116],
                        '616': [3157, 3156],
                        '11': [26, 27, 28],
                        '18': [50, 51, 52],
                        '20': [55, 56, 57],
                        '24': [80, 81, 82],
                        '96': [279, 280],
                        '97': [281, 282],
                        '101': [358, 359, 360],
                        '708': [3400, 3401, 3402],
                        '709': [3403, 3404, 3405],
                        '710': [3406, 3407],
                        '1493': [3403, 3404, 3405],
                    },
                },
                EXPAND_LIST_PRE: {
                    _1481: {
                        gName: '06|Double Chance xxx',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1X', '12', 'X2'],
                        hasSpecialBetValue: true,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1683': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                                specialBetValueHandler: 'firstHalf',
                            },
                            '1702': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                specialBetValueHandler: 'secondHalf',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _1898: {
                        gName: '06|Double Chance xxx',
                        col: 3,
                        row: 2,
                        groupRow: 2,
                        textLocation: 'inside',
                        specialText: [],
                        hasSpecialBetValue: true,
                        specialTextHandler: 'outCome',
                        groupHandler: 'specialBet',
                    },
                    _1834: {
                        gName: '01|3 Way',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1462': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                                specialBetValueHandler: 'firstHalf',
                            },
                            '1615': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                                specialBetValueHandler: 'secondHalf',
                            },
                        },
                    },
                    _1839: {
                        gName: '01|3 Way | Hockey',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1462': {
                                // 1 HT
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '1615': {
                                // 2 HT
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '1464': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                specialBetValueHandler: 'firstHalf',
                            },
                        },
                    },
                    _1469: {
                        gName: '12|Halftime / Fulltime',
                        col: 9,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1535: {
                        gName: 'Matchbet and Totals',
                        col: 6,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: true,
                        groupHandler: 'specialBet',
                    },
                    _1483: {
                        gName: 'Double Chance',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1X', '12', 'X2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1682': {
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1X', '12', 'X2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _1466: {
                        gName: '1st Half - 3way',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1740: {
                        gName: '1st Quarter Winner',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        notRequiredFull: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1741: {
                        gName: '2nd Quarter - 1X2',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1742: {
                        gName: '3rd Quarter - 1X2',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1743: {
                        gName: '4th Quarter - 1X2',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1463: {
                        gName: '01|3 Way | Hockey',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1513: {
                        gName: '03|Handicap',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1777': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '1785': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _1515: {
                        gName: '03|Handicap | Hockey',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1575: {
                        gName: 'Handicap added for American Football',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1836: {
                        gName: '22|Totals',
                        col: 2,
                        textLocation: 'outside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [2],
                    },
                    _1577: {
                        gName: '22|Totals',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['Over', 'Under'],
                        hasSpecialBetValue: true,
                        groupHandler: 'specialBet',
                    },

                    _1517: {
                        gName: '22|Totals | Hockey',
                        col: 2,
                        textLocation: 'outside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [4],
                    },
                    _1732: {
                        gName: '10|Totals Awayteam',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1774': {
                                // 1 HT
                                col: 2,
                                showFirstHalf: true,
                                notRequiredFull: true,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                groupHandler: 'specialBet',
                            },
                            '1779': {
                                // 2 HT
                                col: 2,
                                showFirstHalf: true,
                                notRequiredFull: true,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _1728: {
                        gName: '10|Totals Awayteam | Hockey',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1739: {
                        gName: '09|Totals Hometeam',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1773': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                showFirstHalf: true,
                                notRequiredFull: true,
                            },
                            '1778': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                showFirstHalf: true,
                                notRequiredFull: true,
                            },
                        },
                    },
                    _1735: {
                        gName: '09|Totals Hometeam | Hockey',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1467: {
                        gName: '06|Both Teams to Score',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1690': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['{Yes}', '{No}'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '1691': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['{Yes}', '{No}'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _1486: {
                        gName: 'Draw no bet',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        appendOdds: {
                            '1685': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['{Yes}', '{No}'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                specialTextHandler: 'outCome',
                            },
                        },
                    },
                    _1551: {
                        gName: 'Overtime',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                    },
                    _1468: {
                        gName: '06|Both Teams to Score | Hockey',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1531: {
                        gName: '08|Matchbet + Totals',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        filterHandler: 'reOrder154',
                        groupRow: 2,
                        row: 2,
                    },
                    _1532: {
                        gName: 'Matchbet and Totals',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        filterHandler: 'reOrder154',
                        groupRow: 2,
                        row: 2,
                    },
                    _1794: {
                        gName: '08|Both Score + Totals',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        filterHandler: 'reOrder154',
                        groupRow: 2,
                        row: 2,
                    },
                    _1534: {
                        gName: '08|Matchbet + Totals | Hockey',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        filterHandler: 'reOrder154',
                        groupRow: 2,
                        row: 2,
                    },
                    _1767: {
                        gName: '08|Matchbet + Both Teams to Score',
                        col: 3,
                        row: 1, // Changed from 2 to 1
                        groupRow: 1, // Changed from 2 to 1
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1793': {
                                col: 3,
                                row: 1, // Changed from 2 to 1
                                groupRow: 2, // Changed from 2 to 1
                                showFirstHalf: true,
                                textLocation: 'inside',
                                specialText: [],
                                specialTextHandler: 'outCome',
                                specialTextNotDivide: true,
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _1894: {
                        gName: '08|Both Teams To Score 1st Half / 2nd Half',
                        col: 2,
                        row: 2,
                        groupRow: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1899: {
                        gName: '08|Double Chance and Both Teams Score',
                        col: 3,
                        row: 2,
                        groupRow: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1484: {
                        gName: '13|Draw no bet',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1686': {
                                col: 2,
                                textLocation: 'inside',
                                specialText: [],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '1699': {
                                col: 2,
                                textLocation: 'inside',
                                specialText: [],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _1684: {
                        gName: '1st Half - Draw no bet',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1485: {
                        gName: '13|Draw no bet | Hockey',
                        col: 2,
                        textLocation: 'inside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1516: {
                        gName: '16|Totals',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1642': {
                                // 1 HT
                                col: 2,
                                notRequiredFull: true,
                                showFirstHalf: true,
                                textLocation: 'outside',
                                specialText: [],
                                groupHandler: 'specialBet',
                            },
                            '1644': {
                                // 2 HT
                                col: 2,
                                notRequiredFull: true,
                                showFirstHalf: true,
                                textLocation: 'outside',
                                groupHandler: 'specialBet',
                            },
                        },
                    },

                    _1729: {
                        gName: 'Totals Away',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1736: {
                        gName: 'Totals Home',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1512: {
                        gName: '1st Half - Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1578: {
                        gName: '1st Half - Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1574: {
                        gName: 'Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1734: {
                        gName: 'Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1727: {
                        gName: 'Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1850: {
                        gName: 'Totals Home',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1849: {
                        gName: 'Totals Away',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1851: {
                        gName: 'Winner',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1730: {
                        gName: '1st Half - Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1737: {
                        gName: '1st Half - Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1748: {
                        gName: '1st Quarter - Total Spread',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1749: {
                        gName: '2nd Quarter - Total Spread',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1750: {
                        gName: '3rd Quarter - Total Spread',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1726: {
                        gName: 'Totals Away BB',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1733: {
                        gName: 'Totals Home BB',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1570: {
                        gName: 'Total',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1711: {
                        gName: '1st Set Total',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1510: {
                        gName: '1st Half - Over/Under',
                        col: 2,
                        notRequiredFull: true,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1519: {
                        gName: '05|Total Goals (aggregated)',
                        col: 4,
                        row: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1585: {
                        gName: 'Total number of sets (best of 5)',
                        col: 3,
                        row: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1460: {
                        gName: '05|First Team to score',
                        col: 3,
                        textLocation: 'inside',
                        specialText: ['1', 'None', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1838: {
                        gName: '16|Correct score',
                        gridWidth: 2,
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'correctScore',
                    },
                    // _1877: {
                    //     gName: '16|Correct score',
                    //     gridWidth: 2,
                    //     col: 2,
                    //     textLocation: 'inside',
                    //     specialText: [],
                    //     specialTextHandler: 'outCome',
                    //     hasSpecialBetValue: false,
                    //     groupHandler: 'correctScore',
                    // },
                    _1470: {
                        gName: '14|Halftime/Fulltime',
                        col: 3,
                        row: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1487: {
                        gName: 'home goal ?',
                        col: 4,
                        row: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1488: {
                        col: 4,
                        row: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1689: {
                        gName: '04|First 10 minutes -3 way',
                        col: 3,
                        textLocation: 'inside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1528: {
                        gName: '05|Highest scoring half',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1522: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1526: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1569: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1581: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1586: {
                        col: 4,
                        textLocation: 'inside',
                        specialText: [],
                        notRequiredFull: true,
                        groupRow: 2,
                        row: 2,
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1835: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1524: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1500: {
                        gName: '10|Totals',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1502: {
                        gName: '22|Totals',
                        col: 2,
                        textLocation: 'outside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '1511': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: [],
                                specialTextHandler: 'outCome',
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _1497: {
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        notRequiredFull: true,
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1911: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        notRequiredFull: true,
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1506: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        notRequiredFull: true,
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1461: {
                        gName: 'Next Goal',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1482: {
                        gName: 'Double Chance',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1X', '12', 'X2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1537: {
                        gName: '1st Period - 3way',
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1539: {
                        gName: '1st Period – Total',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['Over', 'Under'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1673: {
                        gName: '1st Period - Both teams to score',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1764: {
                        gName: '2way (incl. OT)',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1848: {
                        gName: 'Double Result',
                        col: 2,
                        textLocation: 'inside',
                        specialTextHandler: 'outCome',
                        specialText: [],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _2014: {
                        gName: '16|Über/Unter Sätze',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['Over', 'Under'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: true,
                        groupHandler: 'specialBet',
                    },
                    _1493: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        notRequiredFull: true,
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _1674: {
                        gName: 'Home to win both halves?',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1675: {
                        gName: 'Home to win either half?',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },

                    _1676: {
                        gName: 'Home to score in both halves?',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1677: {
                        gName: 'Away to win both halves?',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1678: {
                        gName: 'Away to win either half?',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1679: {
                        gName: 'Away to score in both halves?',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1680: {
                        gName: '22|Both halves over 1.5? over',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1681: {
                        gName: '22|Both halves over 1.5? under',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1520: {
                        gName: '1st Half - Correct Score',
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1692: {
                        gName: 'Highest Scoring Half Hometeam',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1693: {
                        gName: 'Highest Scoring Half Awayteam',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1788: {
                        gName: 'Home Win To Nil',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1789: {
                        gName: 'Away Win To Nil',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        onlySupportTypes: [1],
                    },
                    _1591: {
                        gName: '11|Anytime goalscorer',
                        col: 2,
                        gridWidth: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1518: {
                        gName: '11|First goalscorer',
                        col: 2,
                        gridWidth: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1893: {
                        gName: '55|Exact Goals',
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _1902: {
                        gName: '11|Multiscores',
                        col: 2,
                        gridWidth: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                },
                EXPAND_LIST_LIVE: {
                    _11: {
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '101': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                                specialBetValueHandler: 'firstHalf',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _3: {
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        notRequiredFull: true,
                        appendOdds: {
                            '18': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _36: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _616: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _442: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _443: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _517: {
                        gName: '08|Matchbet + Both Teams to Score',
                        col: 3,
                        row: 2,
                        groupRow: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },

                    _708: {
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        notRequiredFull: true,
                        appendOdds: {
                            '20': {
                                col: 3,
                                showFirstHalf: true,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '190': {
                                col: 3,
                                showFirstHalf: true,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _15: {
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _710: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                        appendOdds: {
                            '19': {
                                showFirstHalf: true,
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                notRequiredFull: true,
                                groupHandler: 'specialBet',
                            },
                            '194': {
                                showFirstHalf: true,
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                notRequiredFull: true,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _9: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _268: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _458: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _459: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _866: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _828: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _35: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        // onlySupportTypes: [1, 5],
                    },
                    _134: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '845': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _135: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '846': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _24: {
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1X', '12', 'X2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '195': {
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1X', '12', 'X2'],
                                hasSpecialBetValue: false,
                                notRequiredFull: true,
                                groupHandler: 'specialBet',
                            },
                            '191': {
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1X', '12', 'X2'],
                                hasSpecialBetValue: false,
                                notRequiredFull: true,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _27: {
                        // LIVE BOTH TEAM SCORE
                        gName: '16|Both teams to score',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '736': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['{Yes}', '{No}'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                            '711': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['{Yes}', '{No}'],
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                        },
                        onlySupportTypes: [1],
                    },

                    _514: {
                        gName: '16|Both teams to score | Hockey',
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['{Yes}', '{No}'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        notRequiredFull: true,
                        onlySupportTypes: [4],
                    },
                    _25: {
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        notRequiredFull: true,
                        groupRow: 2,
                        row: 2,
                    },
                    _132: {
                        gName: '19|Exact number of goals',
                        col: 3,
                        groupRow: 3,
                        row: 3,
                        textLocation: 'inside',
                        specialText: ['0', '1', '2'],
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        appendOdds: {
                            '133': {
                                showFirstHalf: true,
                                col: 3,
                                groupRow: 2,
                                row: 2,
                                notRequiredFull: true,
                                textLocation: 'inside',
                                specialText: ['0', '1', '2'],
                                groupHandler: 'specialBet',
                                specialTextHandler: 'outCome',
                            },
                        },
                    },
                    _709: {
                        col: 3,
                        textLocation: 'outside',
                        specialText: ['1', 'X', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '95': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                            '193': {
                                showFirstHalf: true,
                                col: 3,
                                textLocation: 'outside',
                                specialText: ['1', 'X', '2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                            },
                        },
                    },
                    _29: {
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        notRequiredFull: true,
                        groupRow: 2,
                        row: 2,
                    },
                    _154: {
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        specialTextNotDivide: true,
                        hasSpecialBetValue: false,
                        notRequiredFull: true,
                        groupHandler: 'specialBet',
                        filterHandler: 'reOrder154',
                        groupRow: 2,
                        row: 2,
                    },
                    _14: {
                        col: 3,
                        textLocation: 'inside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        specialTextHandler: 'outCome',
                        notRequiredFull: true,
                        appendOdds: {
                            '56': {
                                col: 2,
                                textLocation: 'inside',
                                specialText: ['1', '2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                specialTextHandler: 'outCome',
                                notRequiredFull: true,
                            },
                            '192': {
                                col: 2,
                                textLocation: 'inside',
                                specialText: ['1', '2'],
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                specialTextHandler: 'outCome',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _170: {
                        col: 2,
                        textLocation: 'inside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _8: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _16: {
                        col: 4,
                        textLocation: 'inside',
                        specialText: [],
                        notRequiredFull: true,
                        groupRow: 2,
                        row: 2,
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _77: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['+', '-'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        appendOdds: {
                            '78': {
                                col: 2,
                                textLocation: 'outside',
                                specialText: ['+', '-'],
                                specialTextHandler: 'outCome',
                                hasSpecialBetValue: false,
                                groupHandler: 'specialBet',
                                notRequiredFull: true,
                            },
                        },
                    },
                    _463: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    // '96': [279, 280] => Volleyball
                    _96: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    // '97': [281, 282] => Volleyball
                    _97: {
                        col: 2,
                        textLocation: 'outside',
                        specialText: ['1', '2'],
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _56: {
                        gName: 'Draw No Bet first half',
                        col: 2,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _113: {
                        gName: 'Highest Scoring Half',
                        col: 3,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                    _734: {
                        gName: 'Double chance and Totals',
                        col: 6,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: true,
                        groupHandler: 'specialBet',
                        notRequiredFull: true,
                    },
                    _735: {
                        gName: 'Double chance and both teams to score',
                        col: 6,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                        notRequiredFull: true,
                    },
                    _826: {
                        gName: 'Halftime/Fulltime',
                        col: 9,
                        textLocation: 'inside',
                        specialText: [],
                        specialTextHandler: 'outCome',
                        hasSpecialBetValue: false,
                        groupHandler: 'specialBet',
                    },
                },

                // Ekrandaki Kolon yapısı ayarı buradan yapılıyor.
                // Örnek olarak RoM_tennis => 2 Kolon, MATCHRESULT  => 3 kolon
                DECREASED_ITEM_NUM_BY_SPORT: {
                    '1': ['', 'GOAL_NO_GOAL'],
                    '2': ['RoM_basket', 'HANDICAP_basket'],
                    '3': ['RoM_woDraw', 'HANDICAP_baseball'],
                    '4': ['', ''],
                    '5': ['RoM_tennis', 'SET'],
                    '6': ['', 'HANDICAP_handball'],
                    '12': ['RoM_woDraw', ''],
                    '14': ['RoM_woDraw', ''],
                    '19': ['RoM_woDraw', ''],
                    '35': ['RoM_woDraw', ''],
                    '20': ['RoM_tennis', 'SET'],
                },
            };
            let __data = _data2;
            // let __data = JSON.parse(_data);
            this.ODD_VARIETY = __data.ODD_VARIETY;
            this.ODD_TYPE = __data.ODD_TYPE;
            this.ODD_TYPE_DROPDOWN = __data.ODD_TYPE_DROPDOWN;
            this.ODD_DROPDOWN_BY_SPORT = __data.ODD_DROPDOWN_BY_SPORT;

            this.ODD_TYPE_EQUIVALENT_2ND_ROW = __data.ODD_TYPE_EQUIVALENT_2ND_ROW;
            this.ODD_TYPE_EQUIVALENT = __data.ODD_TYPE_EQUIVALENT;
            this.ODD_TYPE_ID = __data.ODD_TYPE_ID;
            this.ODD_TYPE_SEQUENCE_ID = __data.ODD_TYPE_SEQUENCE_ID;

            this.EXPAND_LIST_PRE = __data.EXPAND_LIST_PRE;
            this.EXPAND_LIST_PRE = this.expandDataJobs(this.EXPAND_LIST_PRE);
            this.EXPAND_LIST_LIVE = __data.EXPAND_LIST_LIVE;
            this.EXPAND_LIST_LIVE = this.expandDataJobs(this.EXPAND_LIST_LIVE);

            this.forbiddenOddTypes = _data.forbiddenOddTypes.map(i => i.OddTypeId);

            this.DECREASED_ITEM_NUM_BY_SPORT = __data.DECREASED_ITEM_NUM_BY_SPORT;
            lg('INIT', 'ODD CONSTANT OKAY..');

            done();
        });
}
